import KeyValuePair from 'shared/models/key-value-pair';

export default interface ReadResidentsChangeLogFilterValue {
  filterValueType: ResidentsChangeLogFilterValueType;
  values: KeyValuePair[];
}

export enum ResidentsChangeLogFilterValueType {
  Location = 'Location',
  Category = 'Category',
  Scenario = 'Scenario',
  Change = 'Change',
  TimeStamp = 'TimeStamp',
  Employee = 'Employee',
  Device = 'Device',
  MuteScenarios = 'MuteScenarios',
}
